<template>
  <path
    d="M20 19.0002H19V5.00024C19 4.45024 18.55 4.00024 18 4.00024H14C14 3.45024 13.55 3.00024 13 3.00024H6C5.45 3.00024 5 3.45024 5 4.00024V19.0002H4C3.45 19.0002 3 19.4502 3 20.0002C3 20.5502 3.45 21.0002 4 21.0002H13C13.55 21.0002 14 20.5502 14 20.0002V6.00024H17V20.0002C17 20.5502 17.45 21.0002 18 21.0002H20C20.55 21.0002 21 20.5502 21 20.0002C21 19.4502 20.55 19.0002 20 19.0002ZM12 13.0002H10V11.0002H12V13.0002Z"
  />
</template>
